 <!-- ========================  Room ======================== -->

 <section class="page">

    <!-- ===  Page header === -->

    <div class="page-header" style="background-image:url(assets/images/header-1.jpg)">
        <div class="container">
            <h2 class="title">{{room.name}}</h2>
            <p>Price: {{room.price | currency:'USD':'symbol':'3.2-2'}}</p>
        </div>
    </div>

    <div class="room">

        <!-- === Booking === -->

        <div class="booking booking-inner">

            <div class="container">

                <div class="booking-wrapper">
                    <div class="row">

                        <!--=== button ===-->

                        <div class="col-xs-12 col-sm-4 col-sm-push-4">
                            <a [routerLink]="['./booking/step-one']" class="btn btn-clean">
                                Book now
                                <small>Best Prices Guaranteed</small>
                            </a>
                        </div>

                    </div> <!--/row-->
                </div><!--/booking-wrapper-->
            </div> <!--/container-->
        </div> <!--/booking-->
        <!-- ===  Room overview === -->

        <div class="room-overview">

            <div class="container">
                <div class="row">

                    <div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">

                        <!-- === Room aminities === -->

                        <div class="room-block room-aminities">

                            <h2 class="title">Room amenities</h2>

                            <div class="row">

                                <!--=== item ===-->

                                <div *ngFor="let amenity of room.amenities" class="col-xs-6 col-sm-2">
                                    <figure>
                                        <figcaption>
                                            <span class="{{amenity.icon}}"></span>
                                            <p>{{amenity.name}}</p>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>

                        </div>

                        <!-- === Room block === -->

                        <!-- <div class="room-block">
                            <h2 class="title">Room overview</h2>
                            <p>
                                The Superior Rooms pay tribute to fashion and craftsmanship. The rooms are approximately 19m2 with views of Rue d'Alger and Jardin des Tuileries.
                                The selection and pairing of materials has been carefully chosen to give you a cool experience. The super soft bed topper is simply extravagant!
                                Every room is different but the colour palette uses unique and expertly matched hues.
                                An openwork brass screen separates the bathroom from the bedroom. This original feature helps make every room your very own cosy and peaceful haven.
                                Bathrobes, slippers and SOTHYS toiletries are provided in the bathroom to pamper you.
                            </p>
                        </div> -->

                    </div> <!--/col-sm-10-->
                </div> <!--/row-->
            </div> <!--/container-->
        </div> <!--/room-overview-->
    </div>

</section>

<!-- ========================  Cards ======================== -->

<section class="cards">

   
    <div class="section-header">
        <div class="container">
            <h2 class="title">Views of {{room.name}} room </h2>
            <p>Here's a sample of room views:</p>
        </div>
    </div>

    <div class="container">
        <div class="row">

            <div *ngFor="let url of room.imageUrls" class="col-xs-6">
                <figure>
                    <!-- <figcaption> -->
                        <img class="img img-responsive" [src]="url" alt="" />
                    <!-- </figcaption> -->
                </figure>
            </div>

            <!-- <div  *ngFor="let url of room.imageUrls" class="image col-xs-4">
                <img [src]="url" alt="" />
            </div> -->

           

            <!-- <div class="col-xs-6 col-md-4">
                <figure>
                    <figcaption style="background-image:url(assets/images/activity-4.jpg)">
                        <img src="assets/images/activity-4.jpg" alt="" />
                    </figcaption>
                </figure>
            </div>

           

            <div class="col-xs-6 col-md-4">
                <figure>
                    <figcaption style="background-image:url(assets/images/activity-5.jpg)">
                        <img src="assets/images/activity-5.jpg" alt="" />
                    </figcaption>
                </figure>
            </div> -->

        </div>

    </div>
</section>




// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/room-detail/room-detail.component.html